import { IEnum } from '@/pages/MDM/mdm.types.ts'
import usePrimitives from '@/pages/MDM/hooks/usePrimitives.ts'
import { useMemo } from 'react'

const usePrimitive = (id: IEnum['id']) => {
  const primitives = usePrimitives()

  return useMemo(() => {
    return primitives.find((p) => p.id === id)
  }, [primitives, id])
}

export default usePrimitive
